import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={427.21}
      height={419.84}
      viewBox="0 0 427.21 419.84"
      {...props}
    >
      <g data-name="Layer 2">
        <g data-name="Background Complete">
          <path
            data-name="Path 11638"
            d="M427.21 282.65H263.35V187.8h163.86zm-162.86-1h161.86V188.8H264.35z"
            fill="#e0e0e0"
          />
          <path
            data-name="Rectangle 1829"
            fill="#f0f0f0"
            d="M285.27 238.37H393.4v3.17H285.27z"
          />
          <path
            data-name="Rectangle 1830"
            fill="#f0f0f0"
            d="M285.27 250.2h115.58v3.46H285.27z"
          />
          <path
            data-name="Rectangle 1831"
            fill="#f0f0f0"
            d="M285.27 262.16h115.58v3.46H285.27z"
          />
          <path
            data-name="Rectangle 1832"
            fill="#f0f0f0"
            d="M285.27 221.21h37.79v8.23h-37.79z"
          />
          <path
            data-name="Rectangle 1833"
            fill="#e0e0e0"
            d="M263.85 188.3h162.86v15.1H263.85z"
          />
          <path
            data-name="Path 11639"
            d="M414.18 201.15c-.21-.2 1.89-2.73 4.68-5.66s5.24-5.13 5.44-4.93-1.89 2.73-4.68 5.65-5.24 5.13-5.44 4.94z"
            fill="#fff"
          />
          <path
            data-name="Path 11640"
            d="M424.3 201.15c-.2.19-2.64-2-5.44-4.94s-4.89-5.45-4.68-5.65 2.64 2 5.44 4.93 4.89 5.46 4.68 5.66z"
            fill="#fff"
          />
          <path
            data-name="Rectangle 1834"
            fill="#e6e6e6"
            stroke="#18206b"
            d="M62.68.5h162.86v93.85H62.68z"
          />
          <path
            data-name="Rectangle 1835"
            fill="#f0f0f0"
            d="M84.11 50.57h108.13v3.17H84.11z"
          />
          <path
            data-name="Rectangle 1836"
            fill="#f0f0f0"
            d="M84.11 62.39h115.58v3.46H84.11z"
          />
          <path
            data-name="Rectangle 1837"
            fill="#f0f0f0"
            d="M84.11 74.35h115.58v3.46H84.11z"
          />
          <path
            data-name="Rectangle 1838"
            fill="#f0f0f0"
            d="M84.11 33.4h37.79v8.23H84.11z"
          />
          <path
            data-name="Rectangle 1839"
            fill="#e0e0e0"
            stroke="#18206b"
            d="M62.68.5h162.86v15.1H62.68z"
          />
          <path
            data-name="Path 11641"
            d="M212.46 13.27c-.21-.2 1.89-2.73 4.68-5.65s5.23-5.13 5.44-4.94-1.89 2.73-4.69 5.66-5.23 5.16-5.43 4.93z"
            fill="#fff"
          />
          <path
            data-name="Path 11642"
            d="M222.58 13.27c-.21.2-2.64-2-5.44-4.93s-4.89-5.46-4.68-5.66 2.64 2 5.43 4.94 4.9 5.45 4.69 5.65z"
            fill="#fff"
          />
          <path
            data-name="Path 11643"
            d="M163.86 174.84H0V79.99h163.86zM1 173.84h161.86V80.99H1z"
            fill="#e0e0e0"
          />
          <path
            data-name="Rectangle 1840"
            fill="#f0f0f0"
            d="M21.93 130.56h108.13v3.17H21.93z"
          />
          <path
            data-name="Rectangle 1841"
            fill="#f0f0f0"
            d="M21.93 142.38h115.58v3.46H21.93z"
          />
          <path
            data-name="Rectangle 1842"
            fill="#f0f0f0"
            d="M21.93 154.34h115.58v3.46H21.93z"
          />
          <path
            data-name="Rectangle 1843"
            fill="#f0f0f0"
            d="M21.93 113.39h37.79v8.23H21.93z"
          />
          <path
            data-name="Rectangle 1844"
            fill="#e0e0e0"
            d="M.5 80.49h162.86v15.1H.5z"
          />
          <path
            data-name="Rectangle 1845"
            fill="#e6e6e6"
            d="M160.67 196.57h192.3v172.16h-192.3z"
          />
          <path
            data-name="Rectangle 1846"
            fill="#f0f0f0"
            d="M19.7 142.34h150.64v156.51H19.7z"
          />
          <path
            data-name="Rectangle 1847"
            fill="#e0e0e0"
            d="M19.7 142.34h150.64v17.05H19.7z"
          />
          <path
            data-name="Path 11644"
            d="M32.14 150.69a3.17 3.17 0 11-3.14-3.31 3.24 3.24 0 013.14 3.31z"
            fill="#fff"
          />
          <path
            data-name="Path 11645"
            d="M45 150.69a3.17 3.17 0 11-3.16-3.31 3.24 3.24 0 013.16 3.31z"
            fill="#fff"
          />
          <path
            data-name="Path 11646"
            d="M57.8 150.69a3.17 3.17 0 11-3.17-3.31 3.24 3.24 0 013.17 3.31z"
            fill="#fff"
          />
          <path
            data-name="Rectangle 1848"
            fill="#f0f0f0"
            d="M213.4 34.73h192.3v191.66H213.4z"
          />
          <path
            data-name="Rectangle 1849"
            fill="#e0e0e0"
            d="M213.4 34.73h192.3v22.45H213.4z"
          />
          <path
            data-name="Path 11647"
            d="M229.78 45.73a4.17 4.17 0 11-4.17-4.36 4.27 4.27 0 014.17 4.36z"
            fill="#fff"
          />
          <path
            data-name="Path 11648"
            d="M245.45 42.78a4.17 4.17 0 11-6-.13 4.26 4.26 0 016 .13z"
            fill="#fff"
          />
          <path
            data-name="Path 11649"
            d="M263.56 45.73a4.17 4.17 0 11-4.17-4.36 4.27 4.27 0 014.17 4.36z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Path 11650"
          d="M364.16 419.58c0 .14-69.44.26-155.08.26S54 419.72 54 419.58s69.43-.26 155.09-.26 155.07.11 155.07.26z"
          fill="#263238"
        />
        <path
          data-name="Path 11651"
          d="M296.5 297.16c-15.45-10.79-18.95-30.83-18.34-48.84.1-3-.23-6.17 1.2-8.81s4.76-4.44 7.46-3.17c2.23 1 3.2 3.65 4.45 5.79a17.58 17.58 0 007.05 6.74c1.91 1 4.28 1.6 6.17.56 2.59-1.43 2.9-5 2.88-8q0-8.35-.1-16.71a27.831 27.831 0 01.9-8.88c.93-2.84 3-5.48 5.83-6.27s6.36.84 7 3.77a27.083 27.083 0 01.08 3.72 3.277 3.277 0 001.84 3c1.17.39 2.39-.5 3.29-1.37 3.08-3 5.18-6.91 7.13-10.78s3.86-7.82 6.66-11.12 6.67-5.9 11-6.14 8.85 2.4 9.93 6.6-1.37 8.5-4 11.91a66.809 66.809 0 01-13.89 13.24 5.46 5.46 0 00-2.33 2.5c-.65 2 1.24 4 3.21 4.63 2.23.74 4.65.51 7 .78s4.85 1.31 5.73 3.51c1.23 3.06-1.33 6.26-3.84 8.36a57.14 57.14 0 01-16.92 9.76c-2.2.81-4.51 1.51-6.29 3.06s-2.84 4.23-1.77 6.34 3.82 2.78 6.13 2.35 4.36-1.68 6.56-2.51c4.11-1.55 9.41-1.26 12 2.29a9.46 9.46 0 011 8.36 21.729 21.729 0 01-4.53 7.39 57.46 57.46 0 01-24.55 17.25c-9.53 3.31-18.36 4.2-27.83.74"
          fill="#b8d98a"
        />
        <path
          data-name="Path 11652"
          d="M356.52 193.1a3.01 3.01 0 01-.29.29l-.89.79c-.78.69-1.93 1.71-3.39 3.07a112.417 112.417 0 00-11.41 12.32c-2.23 2.77-4.54 5.91-7 9.32s-5 7.09-7.52 11.05a135.661 135.661 0 00-7.37 12.78c-1.16 2.28-2.18 4.67-3.23 7.11s-2.1 4.91-3.17 7.42a273.2 273.2 0 00-10.66 28.77 133.84 133.84 0 00-5 24.53 97.42 97.42 0 00-.28 16.88c.15 2 .31 3.54.45 4.58.06.5.1.89.14 1.19a2.529 2.529 0 010 .41 1.526 1.526 0 00-.08-.4c-.08-.26-.11-.69-.19-1.18-.18-1-.37-2.59-.56-4.58a94 94 0 01.11-16.94 131 131 0 014.89-24.64 267.633 267.633 0 0110.63-28.84q1.61-3.76 3.18-7.42c1-2.43 2.08-4.84 3.25-7.14a133.917 133.917 0 017.43-12.81c2.56-4 5.14-7.63 7.57-11s4.77-6.53 7-9.3a106.86 106.86 0 0111.58-12.23c1.48-1.34 2.65-2.33 3.46-3 .39-.31.7-.56.92-.75z"
          fill="#263238"
        />
        <path
          data-name="Path 11653"
          d="M318.36 242.5a6.437 6.437 0 01-.29-1.28c-.16-.82-.34-2-.55-3.51-.43-3-.87-7.11-1.34-11.67s-1-8.67-1.44-11.63c-.23-1.48-.43-2.68-.58-3.5a5.64 5.64 0 01-.16-1.3 6.271 6.271 0 01.37 1.25c.22.81.47 2 .75 3.48.57 3 1.13 7.08 1.6 11.64s.87 8.57 1.18 11.68c.15 1.4.28 2.58.38 3.53a5.62 5.62 0 01.08 1.31z"
          fill="#263238"
        />
        <path
          data-name="Path 11654"
          d="M356.8 235.27a9.453 9.453 0 01-1.53.18c-1 .09-2.42.21-4.18.41-3.52.38-8.36 1.08-13.67 2.08s-10.08 2.13-13.51 3c-1.71.44-3.09.83-4.05 1.1a7.9 7.9 0 01-1.5.37 8.089 8.089 0 011.44-.58c.94-.33 2.3-.78 4-1.27 3.41-1 8.18-2.2 13.51-3.21a136.164 136.164 0 0113.75-1.85c1.77-.16 3.2-.22 4.2-.24a8.051 8.051 0 011.54.01z"
          fill="#263238"
        />
        <path
          data-name="Path 11655"
          d="M301.62 285.16a3.09 3.09 0 01-.26-.47c-.15-.32-.4-.83-.66-1.39-.57-1.21-1.34-3-2.26-5.18-1.86-4.41-4.23-10.57-6.75-17.4s-4.84-13-6.6-17.46l-2.1-5.24c-.22-.58-.41-1.05-.56-1.43a1.932 1.932 0 01-.16-.52 2.529 2.529 0 01.26.47c.18.38.4.83.66 1.39.56 1.21 1.34 3 2.26 5.18 1.86 4.41 4.23 10.57 6.75 17.41s4.83 13 6.59 17.45c.87 2.15 1.58 3.93 2.1 5.25.23.57.42 1 .57 1.43a1.93 1.93 0 01.16.51z"
          fill="#263238"
        />
        <path
          data-name="Path 11656"
          d="M352.7 268.7a2.121 2.121 0 01-.51.21l-1.48.5-5.47 1.77c-4.62 1.5-11 3.64-18 6s-13.41 4.47-18.06 5.87c-2.32.7-4.21 1.25-5.52 1.6l-1.51.4a1.72 1.72 0 01-.54.1 1.9 1.9 0 01.51-.21l1.48-.49 5.47-1.78c4.62-1.49 11-3.64 18-6s13.4-4.46 18.05-5.87c2.33-.7 4.21-1.25 5.53-1.6l1.51-.4a2.13 2.13 0 01.54-.1z"
          fill="#263238"
        />
        <g>
          <path
            data-name="Path 11657"
            d="M331.86 26.12l-5.15 1.85-2.21-6.73c-4.06-12.41-17-19-28.89-14.81s-18.22 17.8-14.16 30.21l2.21 6.73-5.17 1.85a8.22 8.22 0 00-4.82 10.28L288 99.29a7.73 7.73 0 009.86 5.11l53.37-19.1a8.25 8.25 0 004.87-10.37l-14.34-43.79a7.71 7.71 0 00-9.9-5.02zm-40.68 7a13.2 13.2 0 017.76-16.56 12.37 12.37 0 0115.83 8.12L317 31.5l-23.59 8.44zm30 38.85l3.66 11.18a.9.9 0 01-.57 1.12l-5.13 1.84a.82.82 0 01-1-.54l-3.67-11.19a10 10 0 01-9-7 10.51 10.51 0 016.19-13.18 9.83 9.83 0 0112.61 6.45 10.68 10.68 0 01-3.08 11.36z"
            fill="#fb8145"
          />
          <path
            data-name="Path 11658"
            d="M326.48 27.85c0 .13-9.55 3.73-21.44 8s-21.56 7.65-21.61 7.56 9.55-3.73 21.44-8 21.56-7.7 21.61-7.56z"
            fill="#263238"
          />
          <path
            data-name="Path 11659"
            d="M337.82 29.69l.11.26.29.79c.26.72.62 1.74 1.07 3l3.84 11.17c1.6 4.74 3.51 10.36 5.62 16.6 1.05 3.14 2.19 6.39 3.29 9.83a15 15 0 01.75 5.49 7.421 7.421 0 01-.81 2.77 7.6 7.6 0 01-1.89 2.22 17.69 17.69 0 01-5.09 2.62l-5.15 1.86-9.75 3.49-16.5 5.88-11.15 3.92-3 1-.8.26a1.491 1.491 0 01-.27.07.524.524 0 00.25-.12l.78-.31 3-1.13 11.09-4.08 16.48-6 9.73-3.51 5.15-1.86a17.39 17.39 0 004.9-2.41 7.11 7.11 0 001.76-2.07 6.86 6.86 0 00.75-2.57 14.439 14.439 0 00-.72-5.3c-1.08-3.4-2.22-6.68-3.25-9.81-2.08-6.26-3.95-11.89-5.52-16.64S340 36.5 339.1 33.83c-.42-1.3-.74-2.32-1-3.06-.1-.33-.18-.59-.24-.8a1 1 0 01-.04-.28z"
            fill="#263238"
          />
          <path
            data-name="Path 11660"
            d="M309.66 15.9s-.53-.27-1.51-.67a13.62 13.62 0 00-4.37-.87 14.8 14.8 0 00-6.44 1.22 14.37 14.37 0 00-6.11 5.1 13.53 13.53 0 00-2.35 7.6 23.309 23.309 0 001 6.54c.52 1.83 1.06 3.28 1.42 4.28a12.24 12.24 0 01.52 1.58 8.866 8.866 0 01-.71-1.5c-.41-1-1-2.42-1.59-4.25a22.44 22.44 0 01-1.14-6.66 13.73 13.73 0 012.4-7.88 14.61 14.61 0 016.35-5.25 14.77 14.77 0 016.65-1.15 12.56 12.56 0 014.43 1.06 9.928 9.928 0 011.08.59c.26.16.38.24.37.26z"
            fill="#263238"
          />
          <path
            data-name="Path 11661"
            d="M310.12 55.03a2.49 2.49 0 01.5-.25 10.88 10.88 0 011.55-.56 11.14 11.14 0 012.59-.43 8.94 8.94 0 013.51.52c2.56.9 4.91 3.51 6.07 7a10.12 10.12 0 010 5.75 12.92 12.92 0 01-3.27 5.4l.07-.26c1.33 3.64 2.77 7.61 4.28 11.74l.09.25-.25.08-2.29.77-5 1.66-.25.09-.08-.25c-1.37-4.15-2.87-8.06-4-11.79l.21.17a10.05 10.05 0 01-5.35-2.12 12.12 12.12 0 01-3.36-4 9.37 9.37 0 01-1.06-4.5 10.9 10.9 0 01.84-3.87 10.51 10.51 0 013.36-4.39 6.36 6.36 0 011.73-1 16.556 16.556 0 00-1.64 1.09 10.66 10.66 0 00-3.07 4.37 9.48 9.48 0 00.31 8.08 11.84 11.84 0 003.27 3.84 9.59 9.59 0 005.11 2h.17v.16c1.1 3.71 2.61 7.6 4 11.77l-.33-.17 5-1.67 2.28-.76-.16.33c-1.49-4.13-2.93-8.1-4.25-11.75l-.05-.14.11-.12a12.52 12.52 0 003.16-5.17 9.58 9.58 0 000-5.49c-1.09-3.36-3.34-5.92-5.78-6.81a8.59 8.59 0 00-3.39-.57 10.9 10.9 0 00-2.56.35c-1.36.35-2.06.69-2.07.65z"
            fill="#263238"
          />
        </g>
        <g>
          <path
            data-name="Path 11662"
            d="M279.21 343.76l-99.88-.46a21.76 21.76 0 01-21.66-21.8l1.06-250.4a21.77 21.77 0 0121.86-21.67l99.88.47a21.75 21.75 0 0121.66 21.84l-1.06 250.36a21.75 21.75 0 01-21.86 21.66z"
            fill="#455a64"
          />
          <path
            data-name="Path 11663"
            d="M280.33 58.5L261 58.4a4.81 4.81 0 00-4.72 4.89v3.51a4.81 4.81 0 01-4.72 4.9l-37.81-.2a4.81 4.81 0 01-4.68-4.93v-3.52a4.81 4.81 0 00-4.68-4.93h-6.81l-16.95-.08a15.23 15.23 0 00-15.29 15.16l-1 244.41a15.23 15.23 0 0015.16 15.31l99.68.46a15.24 15.24 0 0015.31-15.18l1-244.41a15.23 15.23 0 00-15.16-15.29z"
            fill="#fff"
          />
          <path
            data-name="Path 11664"
            d="M266.91 300.77l-74.12-.34a1.68 1.68 0 01-1.38-1.87l.08-19.39c0-1 .63-1.86 1.4-1.85l74.12.34c.77 0 1.39.84 1.38 1.87l-.08 19.39a1.68 1.68 0 01-1.4 1.85z"
            fill="#fb8145"
          />
          <text
            data-name="SING UP"
            transform="translate(212.91 291.39)"
            fill="#e8e8e3"
            fontSize={8}
            fontFamily="SegoeUI, Segoe UI"
          >
            <tspan x={32} y={0}>
              {"SING UP"}
            </tspan>
          </text>
          <path
            data-name="Rectangle 1850"
            fill="#e8505b"
            d="M181.849 130.184l25.72.117-.022 4.72-25.72-.117z"
          />
          <path
            data-name="Rectangle 1851"
            opacity={0.1}
            d="M181.849 130.184l25.72.117-.022 4.72-25.72-.117z"
          />
          <path
            data-name="Path 11665"
            d="M283 159.27a2.3 2.3 0 00.59-.14 1.56 1.56 0 001-1.34V144.5a1.91 1.91 0 00-.29-1.31 1.46 1.46 0 00-1.18-.61h-16.01l-83.64-.31a1.36 1.36 0 00-1.1.56 1.9 1.9 0 00-.26 1.31v12a8 8 0 000 1.41 1.35 1.35 0 00.78.9 1.4 1.4 0 00.62.1h5.09l22.21.12 37.6.23 25.35.2 6.89.08h-32.24l-37.61-.12-22.2-.09h-5.1a2.11 2.11 0 01-.81-.15 1.89 1.89 0 01-1.08-1.24 2.83 2.83 0 01-.06-.8v-12.74a7.238 7.238 0 010-.79 1.88 1.88 0 011.86-1.59l83.64.46 14.45.11h1.56a1.75 1.75 0 011.4.73 2.15 2.15 0 01.32 1.47v6.4c0 3-.07 5.3-.09 6.9a1.6 1.6 0 01-1.05 1.38 1.2 1.2 0 01-.64.16z"
            fill="#e0e0e0"
          />
          <path
            data-name="Rectangle 1852"
            fill="#e8505b"
            d="M189.43 147.48h47.04v4.41h-47.04z"
          />
          <path
            data-name="Rectangle 1853"
            fill="#fff"
            opacity={0.2}
            d="M189.43 147.48h47.04v4.41h-47.04z"
          />
          <path
            data-name="Rectangle 1854"
            fill="#e8505b"
            d="M181.674 173.243l25.72.117-.022 4.72-25.72-.117z"
          />
          <path
            data-name="Rectangle 1855"
            opacity={0.1}
            d="M181.674 173.243l25.72.117-.022 4.72-25.72-.117z"
          />
          <path
            data-name="Path 11666"
            d="M282.31 202.33a3.348 3.348 0 00.6-.11 2.09 2.09 0 001.26-1.13 2.8 2.8 0 00.18-1.27v-11.95a2.15 2.15 0 00-.29-1.32 2 2 0 00-1.09-.84 6.63 6.63 0 00-1.51-.09h-14.39l-83.35-.31a1.83 1.83 0 00-1.83 1.61v12a5.761 5.761 0 00.06 1.4 1.84 1.84 0 00.73 1 2 2 0 001.24.32h4.35l22.13.12 37.47.23 25.26.2 6.87.08h-32.13l-37.47-.12-22.13-.09h-4.35a2.5 2.5 0 01-1.53-.4 2.42 2.42 0 01-.94-1.32 6.239 6.239 0 01-.08-1.53v-12.05a2.36 2.36 0 012.35-2.07l83.35.46 14.39.1a6.7 6.7 0 011.6.11 2.25 2.25 0 011.23 1 2.41 2.41 0 01.32 1.46v6.39c0 1.53 0 2.81-.05 4v1.59a2.871 2.871 0 01-.21 1.31 2.09 2.09 0 01-1.35 1.14 1.58 1.58 0 01-.69.08z"
            fill="#e0e0e0"
          />
          <path
            data-name="Rectangle 1856"
            fill="#e8505b"
            d="M181.48 218.162l25.72.117-.022 4.72-25.72-.117z"
          />
          <path
            data-name="Rectangle 1857"
            opacity={0.1}
            d="M181.48 218.162l25.72.117-.022 4.72-25.72-.117z"
          />
          <path
            data-name="Path 11667"
            d="M282.12 247.25a4.388 4.388 0 00.6-.12A2.06 2.06 0 00284 246a2.8 2.8 0 00.18-1.27v-11.94a2.15 2.15 0 00-.29-1.32 1.94 1.94 0 00-1.09-.85 6.13 6.13 0 00-1.51-.08H266.9l-83.35-.31a1.85 1.85 0 00-1.83 1.61v12a5.74 5.74 0 00.06 1.4 1.84 1.84 0 00.73 1 2 2 0 001.24.32h4.35l22.13.11 37.47.23 25.26.2 6.87.08H247.7l-37.47-.12-22.23.01h-4.35a2.51 2.51 0 01-1.53-.41 2.4 2.4 0 01-.94-1.31 6.32 6.32 0 01-.08-1.54v-12.05a2.37 2.37 0 012.35-2.07l83.35.46 14.39.11a5.781 5.781 0 011.6.11 2.21 2.21 0 011.23 1 2.39 2.39 0 01.32 1.46v11.97a2.87 2.87 0 01-.21 1.31 2.11 2.11 0 01-1.35 1.15 1.881 1.881 0 01-.66-.01z"
            fill="#e0e0e0"
          />
          <path
            data-name="Rectangle 1858"
            fill="#e8505b"
            d="M188.571 191.394l47.04.213-.02 4.41-47.04-.213z"
          />
          <path
            data-name="Rectangle 1859"
            fill="#fff"
            opacity={0.2}
            d="M188.571 191.394l47.04.213-.02 4.41-47.04-.213z"
          />
          <path
            data-name="Path 11668"
            d="M192.83 239.08a2.06 2.06 0 11-2.05-2.2 2.13 2.13 0 012.05 2.2z"
            fill="#e8505b"
          />
          <path
            data-name="Path 11669"
            d="M199.2 239.11a2.06 2.06 0 11-2-2.2 2.13 2.13 0 012 2.2z"
            fill="#e8505b"
          />
          <path
            data-name="Path 11670"
            d="M205.58 239.14a2.06 2.06 0 11-2.05-2.2 2.14 2.14 0 012.05 2.2z"
            fill="#e8505b"
          />
          <path
            data-name="Path 11671"
            d="M212 239.17a2.06 2.06 0 11-2-2.2 2.13 2.13 0 012 2.2z"
            fill="#e8505b"
          />
          <path
            data-name="Path 11672"
            d="M218.32 239.2a2.06 2.06 0 11-2-2.2 2.12 2.12 0 012 2.2z"
            fill="#e8505b"
          />
          <path
            data-name="Path 11673"
            d="M224.69 239.23a2.06 2.06 0 11-2-2.2 2.11 2.11 0 012 2.2z"
            fill="#e8505b"
          />
          <path
            data-name="Path 11674"
            d="M231.07 239.26a2.06 2.06 0 11-2-2.2 2.13 2.13 0 012 2.2z"
            fill="#e8505b"
          />
          <path
            data-name="Path 11675"
            d="M237.44 239.29a2.06 2.06 0 11-2.05-2.2 2.12 2.12 0 012.05 2.2z"
            fill="#e8505b"
          />
          <path
            data-name="Path 11676"
            d="M243.81 239.32a2.06 2.06 0 11-2-2.2 2.12 2.12 0 012 2.2z"
            fill="#e8505b"
          />
          <g data-name="Group 633" opacity={0.2} fill="#fff">
            <path
              data-name="Path 11677"
              d="M192.83 239.08a2.06 2.06 0 11-2.05-2.2 2.13 2.13 0 012.05 2.2z"
            />
            <path
              data-name="Path 11678"
              d="M199.2 239.11a2.06 2.06 0 11-2-2.2 2.13 2.13 0 012 2.2z"
            />
            <path
              data-name="Path 11679"
              d="M205.58 239.14a2.06 2.06 0 11-2.05-2.2 2.14 2.14 0 012.05 2.2z"
            />
            <path
              data-name="Path 11680"
              d="M212 239.17a2.06 2.06 0 11-2-2.2 2.13 2.13 0 012 2.2z"
            />
            <path
              data-name="Path 11681"
              d="M218.32 239.2a2.06 2.06 0 11-2-2.2 2.12 2.12 0 012 2.2z"
            />
            <path
              data-name="Path 11682"
              d="M224.69 239.23a2.06 2.06 0 11-2-2.2 2.11 2.11 0 012 2.2z"
            />
            <path
              data-name="Path 11683"
              d="M231.07 239.26a2.06 2.06 0 11-2-2.2 2.13 2.13 0 012 2.2z"
            />
            <path
              data-name="Path 11684"
              d="M237.44 239.29a2.06 2.06 0 11-2.05-2.2 2.12 2.12 0 012.05 2.2z"
            />
            <path
              data-name="Path 11685"
              d="M243.81 239.32a2.06 2.06 0 11-2-2.2 2.12 2.12 0 012 2.2z"
            />
          </g>
          <path
            data-name="Path 11686"
            d="M234.76 94.95a3.87 3.87 0 002.31-3.59 3.64 3.64 0 10-7.27 0 3.86 3.86 0 002.32 3.62c-5.6.84-5.35 6.93-5.35 6.93l13.24.06s.3-6.18-5.25-7.02z"
            fill="#e8505b"
          />
          <path
            data-name="Path 11687"
            d="M234.76 94.95a3.87 3.87 0 002.31-3.59 3.64 3.64 0 10-7.27 0 3.86 3.86 0 002.32 3.62c-5.6.84-5.35 6.93-5.35 6.93l13.24.06s.3-6.18-5.25-7.02z"
            opacity={0.1}
          />
          <path
            data-name="Rectangle 1860"
            fill="#e8505b"
            d="M209.08 105.688l47.19.214-.026 5.64-47.19-.214z"
          />
          <path
            data-name="Rectangle 1861"
            fill="#fff"
            opacity={0.2}
            d="M209.08 105.688l47.19.214-.026 5.64-47.19-.214z"
          />
        </g>
        <g data-name="Speech Bubble" fill="#e8505b">
          <path
            data-name="Path 11688"
            d="M82.78 135.12a2.658 2.658 0 01-.46.06l-1.36.09a15.631 15.631 0 00-2.19.3 13.373 13.373 0 00-1.39.26l-1.55.43a25.43 25.43 0 00-7.38 3.66A26 26 0 0061.2 148a27 27 0 00-2.54 5.8 28 28 0 00-1.11 6.78 27.6 27.6 0 00.06 3.63 14.762 14.762 0 00.25 1.84 11.82 11.82 0 00.35 1.85 26.39 26.39 0 0015 18.33 23.75 23.75 0 008.58 1.92 23.21 23.21 0 009-1.29l.88-.32h.12l.1.05 12.61 6.4-.37.32c-1.35-4.18-2.65-8.23-3.91-12.12v-.15l.12-.11a27 27 0 006.62-11 27.68 27.68 0 001-11.72 27.33 27.33 0 00-3.31-9.93 26.81 26.81 0 00-5.7-7 27.74 27.74 0 00-6.2-3.95 26.761 26.761 0 00-5.23-1.64l-2-.34-1.45-.1-.88-.07h.89l1.45.06 2 .3a26.5 26.5 0 015.31 1.59 26.79 26.79 0 0115.53 21 27.92 27.92 0 01-.93 11.91 27.39 27.39 0 01-6.72 11.24l.06-.26c1.26 3.88 2.57 7.93 3.93 12.11l.19.61-.57-.29-12.61-6.4h.22l-.9.33a23.66 23.66 0 01-9.17 1.31 24.09 24.09 0 01-8.77-2 26.26 26.26 0 01-12.53-11.29 26.579 26.579 0 01-2.83-7.4 15.16 15.16 0 01-.35-1.88c-.08-.63-.21-1.25-.24-1.87a29.59 29.59 0 011.11-10.57 27.32 27.32 0 012.61-5.88 26.28 26.28 0 017.41-8.13 25.47 25.47 0 017.49-3.61l1.57-.41a13.726 13.726 0 011.4-.24 13.63 13.63 0 012.21-.24h1.37z"
          />
          <path
            data-name="Path 11689"
            d="M88.49 158.5h-1.85l-4-5.62v-3.69s-2.86-.17-2.52 4.66 0 3.6 0 3.6-6.07 0-6.57.55c-.37.38-.53 6.41-.6 9.67a3.55 3.55 0 002.51 3.57 3 3 0 00.65.08c1.52 0 9.24-1.23 9.24-1.23h3.2z"
          />
          <path
            data-name="Path 11690"
            d="M93.78 157.46l-1.14 12.64h-3.16v-12.39z"
          />
        </g>
        <g>
          <path
            data-name="Path 11691"
            d="M131.47 414.79v-8.56l-15.33-.1-.14 12.92.95.07c4.23.28 21.52.68 24.36-.2 3.17-.98-9.84-4.13-9.84-4.13z"
            fill="#e8505b"
          />
          <path
            data-name="Path 11692"
            d="M141.68 418.12c0 .14-5.74.26-12.81.26s-12.81-.12-12.81-.26 5.74-.26 12.81-.26 12.81.11 12.81.26z"
            fill="#263238"
          />
          <path
            data-name="Path 11693"
            d="M131.74 416.5c-.13-.06 0-.52.31-1s.73-.69.83-.58-.11.47-.41.89-.6.79-.73.69z"
            fill="#263238"
          />
          <path
            data-name="Path 11694"
            d="M132.72 417.1c-.14-.05-.07-.56.23-1.09s.7-.86.81-.77-.07.53-.35 1-.56.91-.69.86z"
            fill="#263238"
          />
          <path
            data-name="Path 11695"
            d="M120.68 418.08c-.06 0-.29-.18-.62-.56a10.519 10.519 0 00-1.34-1.35 3.5 3.5 0 00-1.66-.72c-.47-.07-.77 0-.8-.07s.26-.27.81-.3a3.05 3.05 0 012 .68 5.62 5.62 0 011.32 1.54c.23.44.35.74.29.78z"
            fill="#263238"
          />
          <path
            data-name="Path 11696"
            d="M131.79 414.92c.07.13-.19.42-.63.58s-.83.11-.85 0 .29-.31.67-.46.73-.24.81-.12z"
            fill="#263238"
          />
          <path
            data-name="Path 11697"
            d="M131.54 414.1c0 .14-.39.26-.91.27s-.93-.1-.92-.25.42-.26.92-.27.9.11.91.25z"
            fill="#263238"
          />
          <path
            data-name="Path 11698"
            d="M169.22 414.79v-8.56l-15.33-.1-.13 12.79 1 .07c4.23.28 21.52.81 24.36-.07 3.11-.98-9.9-4.13-9.9-4.13z"
            fill="#e8505b"
          />
          <path
            data-name="Path 11699"
            d="M179.43 418.14c0 .14-5.73.26-12.81.26s-12.81-.12-12.81-.26 5.74-.26 12.81-.26 12.81.11 12.81.26z"
            fill="#263238"
          />
          <path
            data-name="Path 11700"
            d="M169.49 416.5c-.13-.06 0-.52.31-1s.73-.69.83-.58-.11.47-.41.89-.6.79-.73.69z"
            fill="#263238"
          />
          <path
            data-name="Path 11701"
            d="M170.47 417.1c-.13-.05-.07-.56.24-1.09s.69-.86.81-.77-.08.53-.36 1-.56.91-.69.86z"
            fill="#263238"
          />
          <path
            data-name="Path 11702"
            d="M158.43 418.08c-.06 0-.28-.18-.62-.56a10.52 10.52 0 00-1.34-1.35 3.5 3.5 0 00-1.66-.72c-.47-.07-.77 0-.8-.07s.26-.27.81-.3a3 3 0 012 .68 5.619 5.619 0 011.32 1.54c.23.44.35.74.29.78z"
            fill="#263238"
          />
          <path
            data-name="Path 11703"
            d="M169.54 414.92c.07.13-.19.42-.63.58s-.83.11-.85 0 .29-.31.67-.46.73-.24.81-.12z"
            fill="#263238"
          />
          <path
            data-name="Path 11704"
            d="M169.3 414.1c0 .14-.4.26-.92.27s-.92-.1-.92-.25.42-.26.92-.27.9.11.92.25z"
            fill="#263238"
          />
          <path
            data-name="Path 11705"
            d="M225.7 160.89c-.4-.41-1.39-.22-1.39-.22a5.35 5.35 0 000-1.73c-.18-.57-1.44-.46-1.44-.46a5.79 5.79 0 010-1.42.49.49 0 00-.29-.5 4.72 4.72 0 00-1.88-.35c-.78-.55 2.35-4.92 3.51-6.31s1-2.49-.08-2.49c-.71 0-4.35 4.2-5.47 5.61s-4.09 5.33-4.2 2.2-1.35-5.5-2.14-5.9-1.63.54-1.2 1.41a11.37 11.37 0 01.7 3.08 7.68 7.68 0 01-.11 2.53 30.629 30.629 0 01-1.35 4.52l-.08-.05s-21.82 20.93-23.4 22.43c-1.41 1.34-29.78-1.59-35.46-2.2a39.492 39.492 0 00-5.84-.39c-2.47.1-2.91.45-5.37.49a120.354 120.354 0 00-18.54 1.63 15.33 15.33 0 00-12.06 10.46c-5.73 17.89-18.71 60.26-21 84.07a99.853 99.853 0 00-4.68 9.67c-1.61 4.38-1.22 4.53-.68 4.63 1.46.26 3.12-7.59 3.74-5.7s-3.15 9.38-1.62 9.6c2 .28 3.59-8 3.77-8.67s1.19-.44 1 .17c-.29.88-3.1 10.21-1.14 10.51 1.08.17 1.2-1.81 1.2-1.81s2-8.92 2.91-8.75-.06 5.46-.52 7.21.18 2.66 1.12 2.22c.64-.3 2.17-5.64 2.59-7.39s1.46-6.56 2.88-3.76 3.55 4.41 4.43 4.44a1 1 0 00.49-1.79 11.25 11.25 0 01-1.93-2.49 7.37 7.37 0 01-1-2.34 25.37 25.37 0 01-.7-5.06l-.16-1c2.23-11.09 8.69-43.64 18-64.43l3.82 7.86 1.66 5.81-10.19 25.11 43.41-.57-6.47-24.94 7.87-26c8.51.19 30.36.51 34-1.13 4.57-2.05 28.27-31.92 28.27-31.92a56.777 56.777 0 004.43-3.84s1.45-1.16.59-2.05z"
            fill="#ffbe9d"
          />
          <path
            data-name="Path 11706"
            d="M111.71 232.83c1.26-4.3 7.73-25.55 7.73-25.55s3.18 17.33 2.34 19.41a36.38 36.38 0 01-2.73 5.16c-7.34 11.18-6.38 16.77-6.38 16.77l44.33-1.36c.11-6.2-3.56-20.61-4.33-22.91s1.78-9.84 1.78-9.84 5-5.09 4.82-7.7a42.379 42.379 0 00-.87-7l27 1-.86-18.31-38.78-3.88c-1.35 3.82-13.56 2-13.56 2-13.18.43-14 2.86-19.48 7.11S98.17 228.5 98.17 228.5z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 11707"
            d="M137.93 228.5a9.33 9.33 0 01-2.33.12c-1.45 0-3.44-.1-5.63-.32s-4.17-.53-5.58-.81a9.62 9.62 0 01-2.27-.58 10.561 10.561 0 012.32.22c1.43.18 3.4.43 5.58.65s4.16.37 5.59.47a10.549 10.549 0 012.32.25z"
            fill="#263238"
          />
          <path
            data-name="Path 11708"
            d="M141 224.74a10.58 10.58 0 01-2.42.82 43.459 43.459 0 01-12.23 1.45 10.449 10.449 0 01-2.54-.23 15.419 15.419 0 012.54-.13c1.57-.05 3.73-.17 6.11-.45s4.5-.68 6-1a14.349 14.349 0 012.54-.46z"
            fill="#263238"
          />
          <path
            data-name="Path 11709"
            d="M155.88 207.92a9.33 9.33 0 01-.3 2.26c-.26 1.38-.66 3.28-1.17 5.37s-1 3.95-1.45 5.3a9.71 9.71 0 01-.77 2.14 10.179 10.179 0 01.42-2.24c.38-1.56.81-3.35 1.29-5.33s.94-3.76 1.32-5.32a10.36 10.36 0 01.66-2.18z"
            fill="#263238"
          />
          <path
            data-name="Path 11710"
            d="M112.18 230.29a49 49 0 01-6.83-1.6 48.289 48.289 0 01-6.7-2.09 46.482 46.482 0 016.83 1.59 47.461 47.461 0 016.7 2.1z"
            fill="#263238"
          />
          <path
            data-name="Path 11711"
            d="M158.89 199.59a3.251 3.251 0 01-1.14 0 11.35 11.35 0 01-3.05-.72 12.77 12.77 0 01-4-2.43 12.52 12.52 0 01-3.26-4.68 13 13 0 01-.89-5.64 8.75 8.75 0 011.37-4.46 4.57 4.57 0 012.53-1.86 3.149 3.149 0 01.85-.12c.2 0 .3 0 .3.05a11.162 11.162 0 00-1.09.26 4.63 4.63 0 00-2.29 1.88c-1.36 2.14-1.74 6-.29 9.7a12.39 12.39 0 003.09 4.52 13.21 13.21 0 003.79 2.44 20.07 20.07 0 004.08 1.06z"
            fill="#263238"
          />
          <path
            data-name="Path 11712"
            d="M182.2 200.5a83.061 83.061 0 01-.24-9.21 82.762 82.762 0 01.28-9.22 83.315 83.315 0 01.24 9.22 79.686 79.686 0 01-.28 9.21z"
            fill="#263238"
          />
          <path
            data-name="Path 11713"
            d="M145.52 179.75c.11-2.24.34-4.76.34-4.76s5.52-.61 5.85-6.31 0-18.84 0-18.84l-10.05-5.12-11 8.72 1.67 28.51 10.18.64a2.93 2.93 0 003.01-2.84z"
            fill="#ffbe9d"
          />
          <path
            data-name="Path 11714"
            d="M146.51 164.17a.51.51 0 01-.09.25.77.77 0 01-.63.28c-.64 0-1.26-.74-1.48-1.6a2.62 2.62 0 010-1.27 1.07 1.07 0 01.6-.86.5.5 0 01.65.24c.07.17 0 .27 0 .26a.31.31 0 00-.1-.2.36.36 0 00-.47-.1.91.91 0 00-.42.72 2.73 2.73 0 00.05 1.13c.2.77.74 1.4 1.22 1.46a.69.69 0 00.53-.15c.08-.08.12-.16.14-.16z"
            fill="#eb996e"
          />
          <path
            data-name="Path 11715"
            d="M155.14 146.76c-.77-2.62-3.56-3.93-6.1-4.65-3.87-1.09-8.06-1.58-11.83-.19s-8.32 3.84-8.32 8c-2.23-.19-3.51 1.77-4.39 4.19a15.7 15.7 0 00-1 4.6c-.28 5.47-1.81 13-5.35 17-2 2.24-4.77 3.78-5.91 6.55-1 2.42-.48 5.27-1.42 7.71-.82 2.15-2.65 3.68-4 5.55a14.85 14.85 0 00-1 14.39 18.2 18.2 0 0010.89 9.41 25.38 25.38 0 0014.35.13 24 24 0 009.62-4.76 16.09 16.09 0 005.52-9.32c.71-4.09-.44-8.24-1.28-12.29-2.66-12.84-1.9-13.5 1.46-25.41.08-.21.12-.43.18-.65s.09-.3.13-.47a7.439 7.439 0 00.15-1.42 2.73 2.73 0 01-2.84-.63 3 3 0 01-.68-3 4.33 4.33 0 012.58-2.43c1.11-.47 2.3-.7 3.39-1.22 2.31-1.1 3.91-3.38 5-5.77a7.89 7.89 0 00.85-5.32z"
            fill="#263238"
          />
          <path
            data-name="Path 11716"
            d="M146.91 164.42a4.24 4.24 0 01.52 1c.3.63.7 1.52 1.14 2.54l.08.2h-.21l-1 .09c-.69.05-1.28.13-1.95.12a.33.33 0 01-.26-.22.55.55 0 010-.28 1.757 1.757 0 01.1-.41l.18-.7a6.059 6.059 0 01.42-1.39 6.669 6.669 0 01-.21 1.43l-.14.72c0 .24-.14.6 0 .57.5 0 1.21-.1 1.87-.15l1-.08-.13.21c-.43-1-.79-1.93-1-2.59a4 4 0 01-.41-1.06z"
            fill="#e8505b"
          />
          <path
            data-name="Path 11717"
            d="M112.67 248.62l44.33-1.36 19.3 75.34-3.55 86.42h-23.47l2.91-84.58L135 272l2.64 140.37-23.7.35-2.49-132c-.11-3.66-1.31-11.94-.86-15.57z"
            fill="#263238"
          />
          <path
            data-name="Path 11718"
            d="M140.94 273.06a8.291 8.291 0 01-2.17-.13c-1.34-.15-3.17-.43-5.18-.84s-3.82-.85-5.11-1.22a8.471 8.471 0 01-2-.73c0-.14 3.26.64 7.26 1.44s7.26 1.33 7.2 1.48z"
            fill="#455a64"
          />
          <path
            data-name="Path 11719"
            d="M172.53 404.28c0 .15-5.31.26-11.86.26s-11.87-.11-11.87-.26 5.31-.26 11.87-.26 11.86.12 11.86.26z"
            fill="#455a64"
          />
          <path
            data-name="Path 11720"
            d="M137.47 408.73c0 .14-5.16.26-11.52.26s-11.51-.12-11.51-.26 5.15-.23 11.56-.23 11.47.08 11.47.23z"
            fill="#455a64"
          />
          <path
            data-name="Path 11721"
            d="M134.41 408.37c-.14 0-.76-30.67-1.39-68.51s-1-68.51-.87-68.51.77 30.66 1.39 68.51 1.02 68.5.87 68.51z"
            fill="#455a64"
          />
          <path
            data-name="Path 11722"
            d="M169.38 404.28a2.472 2.472 0 010-.4v-1.2c0-1.08.08-2.63.14-4.61.14-4 .34-9.8.58-16.93.55-14.32 1.31-34.05 2.14-55.85v-.51c-5.25-21-10-40.06-13.45-53.86-1.69-6.86-3.06-12.43-4-16.31-.46-1.9-.81-3.4-1.06-4.44-.12-.49-.2-.87-.27-1.15a1.81 1.81 0 01-.07-.4 2.251 2.251 0 01.12.38c.08.28.18.66.32 1.15.27 1 .66 2.52 1.16 4.41 1 3.87 2.41 9.42 4.17 16.28 3.48 13.78 8.28 32.78 13.6 53.81v.66c-.89 21.8-1.7 41.53-2.29 55.85-.31 7.12-.57 12.9-.75 16.92-.1 2-.18 3.52-.23 4.6 0 .51-.06.9-.08 1.2a1.51 1.51 0 01-.03.4z"
            fill="#455a64"
          />
          <path
            data-name="Path 11723"
            d="M161.73 322.95a27.71 27.71 0 01-5.18 1.15c-2.16.37-4 .62-4.83.67v-.2c.26.07.41.13.4.17s-.16 0-.44 0h-.6l.6-.17c.78-.23 2.62-.61 4.78-1a26.1 26.1 0 015.27-.62z"
            fill="#455a64"
          />
          <path
            data-name="Path 11724"
            d="M161.28 325.82a28.084 28.084 0 01-4.66-.21 25.789 25.789 0 01-4.65-.52 17.479 17.479 0 014.69 0 17.54 17.54 0 014.62.73z"
            fill="#455a64"
          />
          <path
            data-name="Path 11725"
            d="M112.48 250.21a6.08 6.08 0 004.37 2.33 20.209 20.209 0 005.38-.1c11.45-1.27 23.58-2.44 34.78-5.18-14.5.82-29.83.54-44.34 1.36l-.15 1.24"
            opacity={0.2}
          />
          <g data-name="Group 634">
            <path
              data-name="Path 11726"
              d="M127.43 270.66l8.18 31.73-.58-30.39z"
              opacity={0.2}
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
